export const filters = {
    categories: [
      { listName: "Smart Watches", listValue: "smart" },
      { listName: "Chain Watches", listValue: "chain" },
      { listName: "Leather Watches", listValue: "leather" },
      { listName: "Rubber Watch", listValue: "rubber" },
      { listName: "Chronograph", listValue: "chronograph" },
    ],
    sortBy: [
      { listName: "Newest", listValue: "newest" },
      { listName: "Lowest To Highest", listValue: "lowest" },
      { listName: "Higest To Lowest", listValue: "highest" },
    ],
    brand: [
      { listName: "APPLE", listValue: "Apple" },
      { listName: "LIGE", listValue: "LIGE" },
      { listName: "SENBONO", listValue: "SENBONO" },
      { listName: "IWO", listValue: "IWO" },
    ],
  };